import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import { defineComponent as _defineComponent } from 'vue';
import IconCalendar from '@/components/general/icons/IconCalendar';
import IconLocation from '@/components/general/icons/IconLocation';
import { EVENT_TYPES } from '~/utils/utils';
import { convertDateToDisplay } from '~/utils/date-time';
export default /*#__PURE__*/_defineComponent({
  __name: 'BEvent',
  props: {
    event: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    provider: {
      type: String,
      default: ''
    }
  },
  setup: function setup(__props) {
    var props = __props;
    var localePath = useLocalePath();
    var _useI18n = useI18n(),
      d = _useI18n.d;
    var eventTypes = EVENT_TYPES;
    var thumbnailFound = ref(true);
    var eventImage = computed(function () {
      if (thumbnailFound.value && props.event.mainImageUri) {
        // This also has a handy side effect of not affecting images not hosted by us,
        // if you specify them like that during the event creation
        return props.event.mainImageUri.replace('16x9', '16x9/thumbnail');
      }
      return props.event.mainImageUri;
    });
    var isExternalEvent = computed(function () {
      return props.event.type === eventTypes.EXTERNAL;
    });
    var placeholderImage = computed(function () {
      return isExternalEvent.value ? require('assets/img/featured_event.webp') : require('assets/img/event_placeholder.webp');
    });
    function formatEventDate(event) {
      var startDate = convertDateToDisplay(event.startAt, event.timezoneName);
      var endDate = convertDateToDisplay(event.endAt, event.timezoneName);
      return "".concat(d(startDate, 'ddd_DD_MMM_YYYY_HH_mm'), " - ").concat(d(endDate, 'HH_mm'));
    }
    return {
      __sfc: true,
      props: props,
      localePath: localePath,
      d: d,
      eventTypes: eventTypes,
      thumbnailFound: thumbnailFound,
      eventImage: eventImage,
      isExternalEvent: isExternalEvent,
      placeholderImage: placeholderImage,
      formatEventDate: formatEventDate,
      IconCalendar: IconCalendar,
      IconLocation: IconLocation
    };
  }
});